<div class="header-helper">
  Your system activity on your account is listed below.
</div>

<div class="content content-with-elevation">
  <div *ngFor="let log of auditLog" style="padding: 15px; border-bottom: 1px solid #C1C7D0">
    <lib-audit-log-individual-section [auditLog]="log"></lib-audit-log-individual-section>
  </div>
</div>
